import { useEffect, useState } from 'react';
import {
  useSuiteAPI,
  UseSuiteAPIReturn,
} from 'src/SharedCustomHooks/UseSuiteAPI/useSuiteAPI';
import {
  ICalendarEventData,
  KEY_PICKUP_EVENT_TYPE,
} from 'src/pages/Calendar/types';

export interface KeyPickupHandoffStatus {
  isHandedOff: boolean;
  isResolving: boolean;
}

/* Is this key-pickup's unit already handed off, so the dialog can swap the CTA for a done state?
 * Fetches the suite only for key-pickup events (isKeyHandOff — the flag the suite page reads);
 * isResolving holds a skeleton until the fetch settles so the dialog never flashes. */
export const useKeyPickupHandoffStatus = (
  originalEvent: ICalendarEventData | null
): KeyPickupHandoffStatus => {
  const { suite, fetchSuiteById }: UseSuiteAPIReturn = useSuiteAPI();

  const isKeyPickup: boolean =
    originalEvent?.juniperEventType === KEY_PICKUP_EVENT_TYPE;

  const suiteId: string = originalEvent?.suiteId ?? '';

  const [isResolving, setIsResolving] = useState<boolean>(
    isKeyPickup && Boolean(suiteId)
  );

  useEffect(() => {
    if (!isKeyPickup || !suiteId) {
      return;
    }

    const resolveHandoff = async (): Promise<void> => {
      setIsResolving(true);

      await fetchSuiteById(suiteId);

      setIsResolving(false);
    };

    resolveHandoff();
  }, [isKeyPickup, suiteId]);

  return {
    isHandedOff: Boolean(suite?.isKeyHandOff),
    isResolving,
  };
};